class StickyPanels {
    constructor(selector = '.panel') {
        this.panels = [...document.querySelectorAll(selector)];

        if (!this.panels.length) return;

        this.resizeObserver = new ResizeObserver(() => {
            this.update();
        });

        this.panels.forEach(panel => {
            this.resizeObserver.observe(panel);
        });

        this.update();
    }

    update() {
        const viewportHeight = window.innerHeight;

        this.panels.forEach(panel => {
            const panelHeight = panel.getBoundingClientRect().height;

            const offset = Math.min(
                0,
                viewportHeight - panelHeight
            );

            panel.style.setProperty(
                '--sticky-offset',
                `${offset}px`
            );
        });
    }
}

export default new StickyPanels();
